import React, { Fragment, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useDeviceRequestBadges, CountBadge } from '../DeviceRequests/deviceRequestApi';
import { hrLogout } from '../../actions/authActions';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { SidebarLogo, SidebarNavList } from '../common/SidebarNav';
import './hrSidebar.css';
import BpGuide from '../common/BpGuide';
import { BillingGapsBadge } from './BillingGapsWorklist';

export const NURSE_DASHBOARD = { to: '/Nurse/Dashboard', icon: 'fas fa-home', label: 'My Dashboard' };

const HRSidebar = (props) => {

    const { isAuthenticated, user } = useSelector(state => state.auth);
    const drBadges = useDeviceRequestBadges();
    const dispatch = useDispatch();

    useEffect(() => {
		if(isAuthenticated === false) {
			props?.history?.push("/login");
		}
	}, [isAuthenticated])


    const logoutHandler = () => {
        dispatch(hrLogout());
    }


    return (
        <Fragment>
            <div className="sidebar hr-white-sidebar">
            <SidebarLogo />
            <br/>

            <SidebarNavList dashboard={NURSE_DASHBOARD} badge={<BillingGapsBadge style={{ marginLeft: 6 }} />}>
{user?.role === 'HrLead' && (<li className="nav_link"><NavLink to="/enrollment/patients" activeClassName="link-name-active"><i className="fas fa-user-plus" style={{color: '#FEFFFF', fontSize: '24px'}}></i><span className="link_name" title="Program Enrollment">Program Enrollment</span></NavLink></li>)}
                <li className="nav_link">
                    <NavLink key="deviceRequests" to="/device-requests" activeClassName="link-name-active">
                        <i className="fas fa-clipboard-list" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Device Requests">Device Requests<CountBadge n={drBadges.returned} bg="warning" title="Returned to you" /></span>
                    </NavLink>
                </li>
                <li className="nav_link">
                    <NavLink key="nurseBonus" to="/billing/nurse-bonus" activeClassName="link-name-active">
                        <i className="fas fa-coins" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="My Bonus Credits">My Bonus Credits</span>
                    </NavLink>
                </li>
                {user?._id && (
                    <li className="nav_link">
                        <NavLink key="myActivity" to={`/nurse-activity/${user._id}`} activeClassName="link-name-active">
                            <i className="fas fa-chart-bar" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                            <span className="link_name" title="My Activity &amp; Bonus">My Activity &amp; Bonus</span>
                        </NavLink>
                    </li>
                )}

                {user?.role === 'HrLead' && (
                <li className="nav_link">
                    <NavLink to="/enrollment/patients" activeClassName="link-name-active">
                        <i className="fas fa-user-plus"></i>
                        <span className="link_name" title="Program Enrollment">Program Enrollment</span>
                    </NavLink>
                </li>
                )}

                {user?.role === 'HrLead' && (
                <li className="nav_link">
                    <NavLink key="deviceAssign" to="/devices/assign" activeClassName="link-name-active">
                        <i className="fas fa-barcode" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Assign / Unassign Devices">Assign / Unassign Devices</span>
                    </NavLink>
                </li>
                )}

                <li className="nav_link">
                    <NavLink key="assignedPts" to="/Nurse/Assigned/Patients" activeClassName="link-name-active">
                        <i className="far fa-user" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Assigned RPM Patients">Assigned RPM Patients</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="hrpatients" to="/Nurse/Patients" activeClassName="link-name-active">
                    <i className="fas fa-user-injured" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Patient List">Patient List</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink to="/CCM/Nurse/Patients" key="nurseCCMPts" activeClassName="link-name-active">
                    <i className="fas fa-hospital-user" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="CCM Patients">CCM Patients</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="timeReport" to="/Nurse/Report/TimeReport" activeClassName="link-name-active">
                    <i className="fas fa-stopwatch-20" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Time Report By Pt.">Time Report By Pt.</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="minuteshistory" to="/Nurse/Minutes/History" activeClassName="link-name-active">
                    <i className="fas fa-file-medical-alt" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Minutes History">Minutes History</span>
                    </NavLink>
                </li>

                <li className="nav_link">
                    <NavLink key="careplans" to="/Nurse/TelemetryDataReport" activeClassName="link-name-active">
                    <i className="fas fa-desktop" style={{color: '#FEFFFF', fontSize: '24px'}}></i>
                        <span className="link_name" title="Telemetry Data Report">Telemetry Data Report</span>
                    </NavLink>
                </li>    

                {/* <li className="nav_link">
                    <NavLink key="careplans" to="/Nurse/careplans" activeClassName="link-name-active">
                    <i className="fas fa-pencil-alt" style={{color: '1D7874', fontSize: '24px'}}></i>
                        <span className="link_name" title="Careplans">Careplans</span>
                    </NavLink>
                </li> */}

 
                <li>
                    <NavLink key="logout" to="#" onClick={logoutHandler} style={{backgroundColor: 'red'}}>
                        <i className="bx bx-log-out"></i>
                        <span className="link_name" style={{color: '#FFF'}}>Logout</span>
                    </NavLink>
                </li>
                <BpGuide />
            </SidebarNavList>
        </div>    
        </Fragment>
    )
}

export default HRSidebar;
